import React, { useState, useEffect, useRef } from "react";
import "./Game5.css";
import { PauseOutlined, RedoOutlined } from "@ant-design/icons";
import { Button } from "antd";

const getRandomPosition = () => {
  const min = 0;
  const max = 19;
  const x = Math.floor(Math.random() * (max - min + 1)) + min;
  const y = Math.floor(Math.random() * (max - min + 1)) + min;
  return { x, y };
};

const initialSnake = [{ x: 10, y: 10 }];

export default function Game5() {
  const [snake, setSnake] = useState(initialSnake);
  const [food, setFood] = useState(getRandomPosition());
  const [bonus, setBonus] = useState(null);
  const [direction, setDirection] = useState({ x: 1, y: 0 });
  const [score, setScore] = useState(0);
  const [gameOver, setGameOver] = useState(false);
  const [paused, setPaused] = useState(false);
  const [speed, setSpeed] = useState(400); // Start slower
  const gameAreaRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (paused) return;
      switch (e.key) {
        case "ArrowUp":
          if (direction.y === 0) setDirection({ x: 0, y: -1 });
          break;
        case "ArrowDown":
          if (direction.y === 0) setDirection({ x: 0, y: 1 });
          break;
        case "ArrowLeft":
          if (direction.x === 0) setDirection({ x: -1, y: 0 });
          break;
        case "ArrowRight":
          if (direction.x === 0) setDirection({ x: 1, y: 0 });
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [direction, paused]);

  useEffect(() => {
    if (!gameOver && !paused) {
      const interval = setInterval(() => {
        setSnake((prevSnake) => {
          const newSnake = [...prevSnake];
          const head = { ...newSnake[0] };
          head.x += direction.x;
          head.y += direction.y;

          if (
            head.x < 0 ||
            head.x >= 20 ||
            head.y < 0 ||
            head.y >= 20 ||
            newSnake.some(
              (segment, index) =>
                index !== 0 && segment.x === head.x && segment.y === head.y
            )
          ) {
            clearInterval(interval);
            setGameOver(true);
            return prevSnake;
          }

          newSnake.unshift(head);

          if (head.x === food.x && head.y === food.y) {
            setFood(getRandomPosition());
            setScore((prevScore) => {
              const newScore = prevScore + 1;
              if (newScore % 5 === 0) {
                setSpeed((prevSpeed) => Math.max(prevSpeed - 50, 100)); // Increase speed slower
                spawnBonus();
              }
              return newScore;
            });
          } else if (bonus && head.x === bonus.x && head.y === bonus.y) {
            setBonus(null);
            setScore((prevScore) => prevScore + 5);
          } else {
            newSnake.pop();
          }

          return newSnake;
        });
      }, speed);

      if (gameOver) {
        clearInterval(interval);
      }

      return () => clearInterval(interval);
    }
  }, [direction, food, bonus, score, gameOver, speed, paused]);

  const spawnBonus = () => {
    const newBonus = getRandomPosition();
    setBonus(newBonus);

    setTimeout(() => {
      setBonus(null);
    }, 5000); // Bonus point visible for 5 seconds
  };

  const handleRestart = () => {
    setSnake(initialSnake);
    setFood(getRandomPosition());
    setBonus(null);
    setDirection({ x: 1, y: 0 });
    setScore(0);
    setGameOver(false);
    setPaused(false);
    setSpeed(400); // Reset speed to initial value
  };

  const handlePauseResume = () => {
    setPaused((prevPaused) => !prevPaused);
  };

  return (
    <div className="Game5-Body">
      <div className="Game5-Controls">
        <div className="Game5-Div2">
          <Button
            className="glow-on-hover"
            onClick={handlePauseResume}
            icon={paused ? <RedoOutlined /> : <PauseOutlined />}
          >
            {paused ? "Resume" : "Pause"}
          </Button>
        </div>

        <div className="Game5-Div">
          <p className="Game5-Text">Snake Game</p>
          <p className="Game5-Text2">Score: {score}</p>
        </div>

        <div className="Game5-Div2">
          {gameOver ? (
            <Button
              className="glow-on-hover"
              onClick={handleRestart}
              icon={<RedoOutlined />}
            >
              Restart Game
            </Button>
          ) : (
            <Button
              className="glow-on-hover"
              onClick={handleRestart}
              icon={<RedoOutlined />}
            >
              New Game
            </Button>
          )}
        </div>
      </div>

      <div className="Game5-Box" ref={gameAreaRef}>
        {snake.map((segment, index) => (
          <div
            key={index}
            className="snake-segment"
            style={{ left: `${segment.x * 20}px`, top: `${segment.y * 20}px` }}
          />
        ))}
        <div
          className="food"
          style={{ left: `${food.x * 20}px`, top: `${food.y * 20}px` }}
        />
        {bonus && (
          <div
            className="bonus"
            style={{ left: `${bonus.x * 20}px`, top: `${bonus.y * 20}px` }}
          />
        )}
      </div>

      {gameOver && (
        <p className="Game5-Text">Game Over! Your score is<span style={{color:'#ff0000', marginLeft:'5px'}}>{score}</span> </p>
      )}
    </div>
  );
}
